var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaestroLogo = function SvgMaestroLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M24.972 12.588c0 6.9-5.589 12.49-12.486 12.49S0 19.487 0 12.588C0 5.69 5.59.098 12.486.098c6.896 0 12.486 5.592 12.486 12.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c6bbd",
    d: "M27.482.098c-2.8 0-5.379.934-7.462 2.491l.01.001c.41.396.862.675 1.21 1.13l-2.598.042c-.407.41-.778.858-1.127 1.323h4.58c.35.418.672.781.964 1.243h-6.375c-.233.403-.45.816-.638 1.246h7.739c.202.428.383.752.537 1.205h-8.734c-.14.431-.258.872-.348 1.321h9.448c.092.433.163.832.212 1.24h-9.847c-.041.41-.063.828-.063 1.248h9.981c0 .443-.031.852-.076 1.25h-9.842c.042.423.105.839.187 1.249h9.433c-.098.404-.21.811-.351 1.234h-8.763c.132.427.293.841.47 1.246h7.756c-.215.455-.459.818-.727 1.244h-6.396c.252.437.53.854.833 1.254l4.601.069c-.392.47-.895.754-1.354 1.166.025.02-.733-.002-2.226-.026a12.444 12.444 0 0 0 8.966 3.804c6.898 0 12.49-5.591 12.49-12.49 0-6.898-5.591-12.49-12.49-12.49z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaestroLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maestro-logo.5e16e284.svg";
export { ForwardRef as ReactComponent };